import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FileType, getSvgIconFromFileType } from '@platform/shared/utilities/file-utility';

@Component({
  selector: 'app-filename-with-icon',
  templateUrl: './filename-with-icon.component.html',
  styleUrls: ['./filename-with-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilenameWithIconComponent {
  @Input({ required: true }) text: string;
  @Input({ required: true }) fileType: FileType;

  get svgIcon() {
    return getSvgIconFromFileType(this.fileType);
  }
}
